import { useMutation } from "@tanstack/react-query";
import type { Flag } from "@unbox/api";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client, useScopedMerchantClient } from "../scoped-merchant-client";

type UpdateFlagPayload = {
  explanation?: string;
  riskTier?: number;
  riskTypeShort?: string;

  actionTaken: "flag_is_correct" | "flag_dismissed" | "add_flag" | "edit_flag";
  feedbackReason: string;
};
export const useUpdateFlag = (flag: Flag) => {
  const scope = useScopedMerchantClient();

  return useMutation({
    mutationFn: async (payload: UpdateFlagPayload) => {
      if (!scope.merchantId) return;

      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].assurance.flag[":id"].$put({
            json: {
              ...payload,
            },
            param: { ...scope.param, id: flag.id },
          })
        : await client.merchant[":merchantId"].assurance.flag[":id"].$put({
            json: {
              ...payload,
            },
            param: { ...scope.param, id: flag.id },
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["video", scope.merchantId, scope.workspaceId, flag.videoId] });
      queryClient.invalidateQueries({ queryKey: ["video", scope.merchantId] });
      queryClient.invalidateQueries({ queryKey: ["assurance-video", scope.merchantId] });
      queryClient.invalidateQueries({ queryKey: ["assurance-overview", scope.merchantId] });
      queryClient.invalidateQueries({ queryKey: ["assurance-overview-v2", scope.merchantId] });
      queryClient.invalidateQueries({ queryKey: ["portfolio-assurance-overview"] });
    },
  });
};
